import React, { useEffect, useState } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Spinner from "../../component/loadingbar/Spinner";
import DropZone from "../../component/dropzone/DropZone";
import moment from "moment";
import MediaPopup from "../../component/mediapopup/MediaPopup";
import DualListBox from "../../component/duallistbox/DualListBox";
import "react-dual-listbox/lib/react-dual-listbox.css";

const animatedComponents = makeAnimated();

const AddCourse = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token, user_type } = config;

  const [chapOptions, setChapOption] = useState([]);
  const [selectedChapOptions, setSelectedChapOption] = useState([]);
  const items = [
    { id: 1, name: "Item 1", selected: false },
    { id: 2, name: "Item 2", selected: false },
    { id: 3, name: "Item 3", selected: false },
    { id: 4, name: "Item 4", selected: false },
    { id: 5, name: "Item 5", selected: false },
  ];
  //---------------------------------------------- state management ---------------------------------------------
  const [loading, setLoading] = useState(false);
  const [fetchComplete, setFetchComplete] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const [selectedTwo, setSelectedTwo] = useState([]);

  //popup;
  const [selectedMaterials, setSelectedMaterials] = useState([]);

  // input state list
  const [formData, setFormData] = useState({
    liveClassStatus: false,
    isChapEnblDuringLiveClass: "0",
    liveClassLink: "",
    recordedVideoLink: "",
    liveClassInstFile: "",
    liveClassDesc: "",
    liveClassStart: "",
    liveClassEnd: "",
  });
  const [onlyMcq, setOnlyMcq] = useState(false);
  const [courseName, setCourseName] = useState("");
  const [checkCourseList, setCheckCourseList] = useState();
  const [courseDuration, setCourseDuration] = useState("");
  const [durationUnit, setDurationUnit] = useState("hours");
  const [price, setPrice] = useState("");
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [category, setCategory] = useState("");
  const [targetAudience, setTargetAudience] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  const [courseType, setCourseType] = useState("");
  const [incentive, setIncentive] = useState("");
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  // const handleSelectedItemsChange = (items) => {
  //   // setSelectedChapters([]);
  //   // let temp = items.map((m) => {
  //   //   return m;
  //   // });
  //   // setSelectedChapters(temp);
  //   // console.log("==============", selectedChapters);
  // };
  const [plans, setPlans] = useState([
    {
      price: "",
      duration: "",
      durationUnit: "days",
      promotional_price: "",
    },
  ]);
  const [descFileLinkValue, setDescFileLinkValue] = useState("");
  const [descFileImageValue, setDescFileImageValue] = useState();
  const [imageLinkValue, setImageLinkValue] = useState("");
  const [imageFileImageValue, setImageFileImageValue] = useState();
  const [videoLinkValue, setVideoLinkValue] = useState("");
  const [videoFileImageValue, setVideoFileImageValue] = useState();
  const [videoThumbnailValue, setVideoThumbnailValue] = useState("");
  const [videoThumbnailFileImageValue, setVideoThumbnailFileImageValue] = useState();
  const [materialsLinkValue, setMaterialsLinkValue] = useState([]);
  const [materialsFileImageValue, setMaterialsFileImageValue] = useState();

  const handleOnlyMcqBtn = () => {
    setOnlyMcq(!onlyMcq);
  };
  const handlePlanChange = (e, i) => {
    setPlans((prevPlans) => {
      const newPlans = [...prevPlans];
      newPlans[i] = {
        ...newPlans[i],
        [e.target.name]: e.target.value,
      };
      return newPlans;
    });
  };
  const handleCourseNameChange = (event) => {
    setCourseName(event.target.value);
  };
  const handleCourseDurationChange = (event) => {
    setCourseDuration(event.target.value);
  };
  const handleCourseTypeChange = (event) => {
    setCourseType(event.target.value);
  };
  const handleDurationUnitChange = (event) => {
    setDurationUnit(event.target.value);
  };
  const handleStartDateTimeChange = (event) => {
    setStartDateTime(event.target.value);
  };
  const handleEndDateTimeChange = (event) => {
    setEndDateTime(event.target.value);
  };
  const handleTeachersChange = (selectedOptions) => {
    setSelectedTeachers(selectedOptions);
  };

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };
  const handleTargetAudienceChange = (event) => {
    setTargetAudience(event.target.value);
  };
  const handleShortDescriptionChange = (event) => {
    setShortDescription(event.target.value);
  };
  const handleLongDescriptionChange = (event) => {
    setLongDescription(event.target.value);
  };
  const incentiveValueChange = (e) => {
    setIncentive(e.target.value);
  };
  const handleLiveClassLinkBtn = () => {
    setFormData((prevData) => ({
      ...prevData,
      liveClassStatus: !prevData.liveClassStatus,
    }));
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "liveClassInstFile") {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  // Function to handle the change chapter event
  const handleChapChange = (newValue) => {
    const filteredValues = newValue.filter((value) => value >= 0);
    setSelectedChapters(filteredValues);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setCourseName("");
    setCourseDuration("");
    setDurationUnit("hours");
    setPrice("");
    setStartDateTime("");
    setEndDateTime("");
    setCategory("");
    setCourseType("");
    setTargetAudience("");
    setShortDescription("");
    setLongDescription("");
    setSelectedTeachers([]);
    setSelectedChapters([]);
    setPlans([
      {
        price: "",
        duration: "",
        durationUnit: "days",
        promotional_price: "",
      },
    ]);
    setFormData({
      liveClassStatus: false,
      isChapEnblDuringLiveClass: "0",
      liveClassLink: "",
      recordedVideoLink: "",
      liveClassInstFile: {},
      liveClassDesc: "",
      liveClassStart: "",
      liveClassEnd: "",
    });
    setDescFileLinkValue("");
    setImageLinkValue("");
    setVideoLinkValue("");
    setVideoThumbnailValue("");
    setMaterialsLinkValue([]);
    setSelectedMaterials([]);

    if (id) {
      navigate("/viewcourses");
    }
  };

  //--------------------------------------- functionality for plans  ---------------------------------------
  const handleAddPlanBtn = () => {
    setPlans((oldPlans) => {
      return [
        ...oldPlans,
        {
          price: "",
          duration: "",
          durationUnit: "days",
          promotional_price: "",
        },
      ];
    });
  };
  const handleRemovePlanBtn = (index) => {
    const planlist = [...plans];
    planlist.splice(index, 1);
    setPlans(planlist);
  };

  useEffect(() => {
    console.log("chapOptions: ", chapOptions);
  }, [chapOptions]);
  useEffect(() => {
    console.log("selectedChapters: ", selectedChapters);
  }, [selectedChapters]);
  // ---------------------------------------  Fetch teacher, media and chapter ---------------------------------------
  useEffect(() => {
    if (id) {
      setCheckCourseList(true);
    }
    // Fetch media items
    fetch(`${config.host_url}media`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          // Successful response, update the media list
          setMediaList(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching media:", error);
      });

    // Fetch check-course
    {
      !id &&
        fetch(`${config.host_url}course/check-course`, {
          method: "GET",
          headers: {
            token: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {
              setCheckCourseList(data?.isEnable);
            } else if (data.status === 401) {
              // Invalid token
              console.error("Invalid token");
            } else {
              // Handle other errors
              console.error("Internal server error");
            }
          })
          .catch((error) => {
            console.error("Error fetching check-course:", error);
          });
    }

    // Fetch teacher list
    fetch(`${config.host_url}teacher`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          const teacherOptions = data.data.map((teacher) => ({
            value: teacher.fname + " " + teacher.lname,
            label: teacher.fname + " " + teacher.lname,
            id: teacher.tid,
          }));
          setTeachers(teacherOptions);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching teacher:", error);
      });

    // Fetch chapter list
    fetch(`${config.host_url}chapter`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          // const chapterOptions = data.data.map((chapter) => ({
          //   value: chapter.chapterid,
          //   label: chapter.name,
          //   // id: chapter.chapterid,
          // }));
          const chapterOptions = data.data.map((chapter) => ({
            id: chapter.chapterid,
            name: chapter.name,
            selected: false,
          }));

          // setChapters(chapterOptions);

          setChapOption(chapterOptions);
          setFetchComplete(true);
          console.log("~~~~~~~~~~~~~", chapOptions);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chapter:", error);
      });
  }, [token]);
  useEffect(() => {
    if (id !== undefined && fetchComplete) {
      console.log("``````````````", chapOptions);
      updateFieldValueSet();
    }
  }, [id, fetchComplete]);
  // --------------------------------------- Read / Select / Get Selected course data for edit ---------------------------------------R
  const updateFieldValueSet = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}course/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            function formatDateToInput(value) {
              const date = new Date(value);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const day = String(date.getDate()).padStart(2, "0");
              const hours = String(date.getHours()).padStart(2, "0");
              const minutes = String(date.getMinutes()).padStart(2, "0");
              const seconds = String(date.getSeconds()).padStart(2, "0");
              return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            }

            // Successful response, update the media list
            const selectedTeacherOptions = data.data.teachers.map(
              (teacher) => ({
                value: teacher.teacher_name,
                label: teacher.teacher_name,
                id: teacher.tid,
              })
            );
            setSelectedTeachers(selectedTeacherOptions);

            // chapOptions
            console.log(
              "data.data?.chapters1",
              data.data?.chapters,
              chapOptions.length
            );
            const updatedChapOptions = chapOptions.map((option, index) => {
              const match = data.data?.chapters.find(
                (chapter) => chapter.chapterid === option.id
              );
              console.log(index, match);
              if (match) {
                return {
                  id: option.id,
                  name: option.name,
                  selected: true,
                };
              } else {
                return option;
              }
            });
            const sChapOptions = [];
            for (let index = 0; index < data.data?.chapters.length; index++) {
              var option = data.data?.chapters[index];
              const match = chapOptions.find(
                (chapter) => chapter.id === option.chapterid
              );
              console.log(index, match);
              if (match) {
                console.log(index, "option.id", option.id);
                sChapOptions.push({
                  id: option.chapterid,
                  name: option.name,
                  selected: true,
                });
              }
            }

            console.log("new chapOptions", chapOptions);
            setSelectedChapOption(sChapOptions);
            setChapOption(updatedChapOptions);

            //I'm here

            //here I want to check if chapOptions

            const selectedChapterOptions = data.data?.chapters
              .filter((chapter) => chapter.chapterid) // Filter out empty values
              .map((chapter) => chapter.chapterid);

            // setSelectedChapters(selectedChapterOptions);
            handleChapChange(selectedChapterOptions);
            console.log("selectedChapterOptions: ", selectedChapterOptions);

            //update formate of start date time
            const filterStartDateTime = formatDateToInput(
              data.data?.start_date
            );
            setStartDateTime(filterStartDateTime);

            //update formate of end date time
            const filterEndDateTime = formatDateToInput(data.data?.end_date);
            setEndDateTime(filterEndDateTime);

            setCourseName(data.data?.course_name);
            setImageLinkValue(data.data?.image_link);
            setMaterialsLinkValue(
              data.data?.materials.map((mat) => mat.material)
            );
            setVideoLinkValue(data.data?.video_link);
            setVideoThumbnailValue(data.data?.video_thumbnail);
            setDescFileLinkValue(data.data?.description_file);
            setCourseDuration(data.data?.course_duration);
            setDurationUnit(data.data?.duration_unit);
            setPrice(data.data?.price);
            setCourseType(data.data?.course_type && data.data?.course_type);
            setCategory(data.data?.category);
            setTargetAudience(data.data?.target_audience);
            setShortDescription(data.data?.short_description);
            setLongDescription(data.data?.long_description);
            setIncentive(data.data?.incentive);
            const startDate = new Date(data.data?.live_class_start);
            const endDate = new Date(data.data?.live_class_end);

            setFormData({
              liveClassStatus:
                data.data?.live_class_status === 1 ? true : false,
              liveClassLink: data.data?.live_class_link,
              recordedVideoLink: data.data?.live_class_recorded_video_link,
              liveClassDesc: data.data?.live_class_description,
              isChapEnblDuringLiveClass:
                data.data?.is_chapter_enable_during_live_class,
              liveClassInstFile: data.data?.live_class_instruction_file,
              liveClassStart: formatDateToInput(startDate),
              liveClassEnd: formatDateToInput(endDate),
            });
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };

  const handleSelectMaterialsMedia = async (media) => {
    // Check if the media is already in selectedMaterials
    const isMediaSelected = selectedMaterials?.some(
      (selectedMedia) => selectedMedia.media_name === media.media_name
    );

    if (isMediaSelected) {
      // Media is already selected, remove it
      setSelectedMaterials((prevSelectedMaterials) =>
        prevSelectedMaterials.filter(
          (selectedMedia) => selectedMedia.media_name !== media.media_name
        )
      );
      setMaterialsLinkValue((prevMaterialsLinkValue) =>
        prevMaterialsLinkValue.filter((value) => value !== media.media_name)
      );
    } else {
      // Media is not selected, add it
      setSelectedMaterials((prevSelectedMaterials) => [
        ...prevSelectedMaterials,
        media,
      ]);
      setMaterialsLinkValue((prevMaterialsLinkValue) => [
        ...prevMaterialsLinkValue,
        media.media_name,
      ]);
    }
  };

  // Function to clear the selected desc file media
  const clearSelectedMaterialsMedia = () => {
    setSelectedMaterials(null);
  };

  // ---------------------------------------------- create / add / update course ----------------------------------------------------c--u
  // Function to create a new course
  const createCourse = async () => {
    // console.log("imageLinkValue: ", imageLinkValue);
    try {
     
      if (
        !courseName.trim() ||
        !courseType.trim() ||
        !shortDescription.trim() ||
       // !longDescription.trim() ||
        (!id &&
          !plans.every(
            (plan) =>
              plan.duration !== "" &&
              plan.durationUnit !== "" &&
              plan.price !== ""
          )) ||
        (!onlyMcq &&
          (!category.trim() ||
            !targetAudience.trim() ||
            !durationUnit.trim() ||
            !startDateTime.trim() ||
            !endDateTime.trim() ||
            // !imageLinkValue.trim() ||
            // materialsLinkValue.length === 0 ||
            // !videoLinkValue.trim() ||
            // !descFileLinkValue.trim() ||
            // !videoThumbnailValue.trim() ||
            (formData.liveClassStatus &&
              (formData.liveClassLink === "" ||
                formData.liveClassLink === null ||
                formData.liveClassLink === undefined ||
                formData.liveClassStart === "" ||
                formData.liveClassStart === null ||
                formData.liveClassStart === undefined ||
                formData.liveClassDesc === "" ||
                formData.liveClassDesc === null ||
                formData.liveClassDesc === undefined ||
                (!id &&
                  (formData.liveClassInstFile === "" ||
                    formData.liveClassInstFile === null ||
                    formData.liveClassInstFile === undefined)))) ||
            (user_type === "TPT" && (incentive === "" || incentive === null))))
      ) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return; // Stop form submission
      } else if (!onlyMcq && (courseDuration <= 0 || price <= 0)) {
        triggerNotification("error", "Please enter valid price and duration ");
        return;
      } else if (!onlyMcq && selectedTeachers.length <= 0) {
        triggerNotification("error", "Please add teachers");
        return;
      } else if (!onlyMcq && selectedChapters.length <= 0) {
        triggerNotification("error", "Please add chapters");
        return;
      }

      const data = new FormData();

      // Helper function to append field if it exists
      const appendIfExists = (key, value) => {
        if (value !== undefined && value !== null) {
          data.append(key, value);
        }
      };

      function appendArray(data, key, array, mapper = (item) => item) {
        if (array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            data.append(key, mapper(array[i]));
          }
        } else {
          data.append(key, []);
        }
      }

      appendIfExists("course_name", courseName);
      if(imageFileImageValue){
        appendIfExists("image_link", imageFileImageValue);
      }else{
        appendIfExists("image_link", imageLinkValue);
      }
      //appendIfExists("image_link", imageLinkValue);
      appendIfExists("course_duration", courseDuration);
      appendIfExists("duration_unit", durationUnit);
      appendIfExists("price", price);
      appendIfExists("only_mcq", onlyMcq ? "1" : "0");
      appendIfExists("start_date", startDateTime);
      appendIfExists("end_date", endDateTime);
      appendIfExists("category", category);
      appendIfExists("course_type", courseType);
      appendIfExists("target_audience", targetAudience);
      appendIfExists("short_description", shortDescription);
      appendIfExists("long_description", longDescription);
      if(videoFileImageValue){
        appendIfExists("video_link", videoFileImageValue);
      }else{
        appendIfExists("video_link", videoLinkValue);
      }
      //appendIfExists("video_link", videoLinkValue);
      if(videoThumbnailFileImageValue){
        appendIfExists("video_thumbnail", videoThumbnailFileImageValue);
      }else{
        appendIfExists("video_thumbnail", videoThumbnailValue);
      }
     // appendIfExists("video_thumbnail", videoThumbnailValue);
     if(descFileImageValue){
      appendIfExists("description_file", descFileImageValue);
     }else{
      appendIfExists("description_file", descFileLinkValue);
     }
     // appendIfExists("description_file", descFileLinkValue);
      appendIfExists("live_class_link", formData.liveClassLink);
      appendIfExists(
        "live_class_recorded_video_link",
        formData.recordedVideoLink
      );
      appendIfExists("live_class_start", formData.liveClassStart);
      // appendIfExists("live_class_end", formData.liveClassEnd);
      appendIfExists("live_class_description", formData.liveClassDesc);
      appendIfExists(
        "is_chapter_enable_during_live_class",
        formData.isChapEnblDuringLiveClass
      );
      appendIfExists("live_class_status", formData.liveClassStatus ? "1" : "0");
      appendIfExists("status", user_type === "TPT" ? "0" : "1");
      appendIfExists("incentive", incentive);
       if(materialsFileImageValue){
        appendIfExists("materials", materialsFileImageValue);
       }else{
        appendIfExists("materials", materialsLinkValue);
       }
      //appendArray(data, "materials[]", materialsLinkValue);
      appendArray(
        data,
        "teachers[]",
        selectedTeachers,
        (teacher) => teacher.id
      );
      appendArray(
        data,
        "chapters[]",
        selectedChapters,
        (chapter) => chapter.id
      );
      // appendArray(data, "chapters[]", selectedChapters);
      appendArray(data, "plan_for[]", plans, (plan) => plan.duration);
      appendArray(data, "plan_unit[]", plans, (plan) => plan.durationUnit);
      appendArray(data, "plan_price[]", plans, (plan) => plan.price);
      appendArray(
        data,
        "promotional_price[]",
        plans,
        (plan) => plan.promotional_price
      );

      // Append file field if it exists
      if (formData.liveClassInstFile) {
        data.append("live_class_instruction_file", formData.liveClassInstFile);
      }

      fetch(
        `${config.host_url}course/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            token: token,
          },
          body: data,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log("data : ", data);
          if (data.status === 200) {
            // Course created successfully

            triggerNotification(
              "success",
              `Course ${id ? "updated" : "created"} successfully.`
            );

            // Reset form fields after successful creation
            setCourseName("");
            setImageLinkValue("");
            setMaterialsLinkValue("");
            setCourseDuration("");
            setDurationUnit("hours");
            setStartDateTime("");
            setEndDateTime("");
            setPrice("");
            setCategory("");
            setTargetAudience("");
            setShortDescription("");
            setLongDescription("");
            setCourseType("");
            setVideoLinkValue("");
            setVideoThumbnailValue("");
            setDescFileLinkValue("");

            setSelectedTeachers([]);
            setSelectedChapters([]);
            setPlans([
              {
                price: "",
                duration: "",
                durationUnit: "days",
                promotional_price: "",
              },
            ]);
            user_type === "TPT"
              ? navigate("/coursesforapproval")
              : navigate("/viewcourses");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating course:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the course."
      );
    }
  };

  // ---------------------------------------------- save course ----------------------------------------------------c
  // Function to create a new course
  const saveCourse = async () => {
    // console.log("imageLinkValue: ", imageLinkValue);
    try {
      if (!courseName.trim()) {
        triggerNotification("error", "Course name fields cannot be empty!!");
        return; // Stop form submission
      }

      const data = new FormData();

      // Helper function to append field if it exists
      const appendIfExists = (key, value) => {
        if (value !== undefined && value !== null) {
          data.append(key, value);
        }
      };

      function appendArray(data, key, array, mapper = (item) => item) {
        if (array.length > 0) {
          for (let i = 0; i < array.length; i++) {
            data.append(key, mapper(array[i]));
          }
        } else {
          data.append(key, []);
        }
      }

      appendIfExists("course_name", courseName);
      if(imageFileImageValue){
        appendIfExists("image_link", imageFileImageValue);
      }else{
        appendIfExists("image_link", imageLinkValue);
      }
     // appendIfExists("image_link", imageLinkValue);
      appendIfExists("course_duration", courseDuration);
      appendIfExists("duration_unit", durationUnit);
      appendIfExists("price", price);
      appendIfExists("only_mcq", onlyMcq ? "1" : "0");
      appendIfExists("start_date", startDateTime);
      appendIfExists("end_date", endDateTime);
      appendIfExists("category", category);
      appendIfExists("course_type", courseType);
      appendIfExists("target_audience", targetAudience);
      appendIfExists("short_description", shortDescription);
      appendIfExists("long_description", longDescription);
      if(videoFileImageValue){
        appendIfExists("video_link", videoFileImageValue);
      }else{
        appendIfExists("video_link", videoLinkValue);
      }
      //appendIfExists("video_link", videoLinkValue);
      if(videoThumbnailFileImageValue){
        appendIfExists("video_thumbnail", videoThumbnailFileImageValue);
      }else{
        appendIfExists("video_thumbnail", videoThumbnailValue);
      }
      //appendIfExists("video_thumbnail", videoThumbnailValue);
      if (descFileImageValue) {
        appendIfExists("description_file", descFileImageValue);
      } else {
        appendIfExists("description_file", descFileLinkValue);
      }
     // appendIfExists("description_file", descFileLinkValue);
      appendIfExists("live_class_link", formData.liveClassLink);
      appendIfExists(
        "live_class_recorded_video_link",
        formData.recordedVideoLink
      );
      appendIfExists("live_class_start", formData.liveClassStart);
      // appendIfExists("live_class_end", formData.liveClassEnd);
      appendIfExists("live_class_description", formData.liveClassDesc);
      appendIfExists(
        "is_chapter_enable_during_live_class",
        formData.isChapEnblDuringLiveClass
      );
      appendIfExists("live_class_status", formData.liveClassStatus ? "1" : "0");
      appendIfExists("status", "3");
      appendIfExists("incentive", incentive);
      if(materialsFileImageValue){
        appendIfExists("materials", materialsFileImageValue);
      }else{
        appendIfExists("materials", materialsLinkValue);
      }
     // appendArray(data, "materials[]", materialsLinkValue);
      appendArray(
        data,
        "teachers[]",
        selectedTeachers,
        (teacher) => teacher.id
      );
      appendArray(
        data,
        "chapters[]",
        selectedChapters,
        (chapter) => chapter.id
      );
      appendArray(data, "plan_for[]", plans, (plan) => plan.duration);
      appendArray(data, "plan_unit[]", plans, (plan) => plan.durationUnit);
      appendArray(data, "plan_price[]", plans, (plan) => plan.price);
      appendArray(
        data,
        "promotional_price[]",
        plans,
        (plan) => plan.promotional_price
      );

      // Append file field if it exists
      if (formData.liveClassInstFile) {
        data.append("live_class_instruction_file", formData.liveClassInstFile);
      }

      fetch(
        `${config.host_url}course/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            token: token,
          },
          body: data,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log("data : ", data);
          if (data.status === 200) {
            // Course created successfully

            triggerNotification("success", `Course save successfully.`);

            // Reset form fields after successful creation
            setCourseName("");
            setImageLinkValue("");
            setMaterialsLinkValue("");
            setCourseDuration("");
            setDurationUnit("hours");
            setStartDateTime("");
            setEndDateTime("");
            setPrice("");
            setCategory("");
            setTargetAudience("");
            setShortDescription("");
            setLongDescription("");
            setCourseType("");
            setVideoLinkValue("");
            setVideoThumbnailValue("");
            setDescFileLinkValue("");

            setSelectedTeachers([]);
            setSelectedChapters([]);
            setPlans([
              {
                price: "",
                duration: "",
                durationUnit: "days",
                promotional_price: "",
              },
            ]);
            user_type === "TPT"
              ? navigate("/coursesforapproval")
              : navigate("/viewcourses");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error saving course:", error);
      triggerNotification(
        "error",
        "An error occurred while saving the course."
      );
    }
  };

  // Separate arrays for videos and images
  const videos = [];
  const images = [];
  const files = [];

  mediaList.forEach((media) => {
    if (media.media_type === "video") {
      videos.push(media);
    } else if (media.media_type === "image") {
      images.push(media);
    }
    if (media.media_type !== "video") {
      files.push(media);
    }
  });

  return (
    <>
      <Breadcrumb txt="Manage Course" subpath={["Add Course"]} />
      {/* form view */}
      {checkCourseList === true ? (
        <>
          <DropZone url="course/excel" navigate="viewcourses" />
          <div className="col-xxl">
            <div className="card mb-4">
              <div className="card-header d-flex align-items-center ">
                <h5 className="mb-0">Add Course</h5>
              </div>
              {loading ? (
                <Spinner />
              ) : (
                <div className="card-body">
                  <form>
                    {/* Course name | course_type */}
                    <div className="row">
                      {/* Course name */}
                      <div className="col-lg-9">
                        <div className="form-floating form-floating-outline mb-1">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Course Name"
                            value={courseName}
                            onChange={handleCourseNameChange}
                          />
                          <label htmlFor="basic-default-fullname">
                            Course Name
                          </label>
                        </div>
                      </div>
                      {/* course_type */}
                      <div className="col-sm-3">
                        <div className="form-floating form-floating-outline mb-1">
                          <select
                            className="form-select"
                            id="cTyp"
                            name="course_type"
                            aria-label="Default select example"
                            value={courseType}
                            onChange={handleCourseTypeChange}
                          >
                            <option
                              value=""
                              disabled
                              selected
                              className="text-center"
                            >
                              - Select Course Type -
                            </option>
                            <option value="Watch Free">Watch Free</option>
                            <option value="Paid">Paid</option>
                          </select>
                          <label htmlFor="cTyp">Course Type</label>
                        </div>
                      </div>
                    </div>

                    {/* Contain only mcq checkbox */}
                    <div className="row mb-3">
                      <div className="col-sm-3 ">
                        <div
                          className=" select-none"
                          id="onlymcq"
                          name="onlymcq"
                          onClick={handleOnlyMcqBtn}
                        >
                          {onlyMcq ? (
                            <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                          ) : (
                            <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                          )}
                          <span>Contain Only MCQ</span>
                          <span
                            style={{
                              visibility: onlyMcq ? "hidden" : "visible",
                            }}
                          >
                            ?
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Course Duration | Duration unit | Price | End Date | Start Date | Category | Target Audience  */}
                    {!onlyMcq && (
                      <>
                        {/* Course Duration | Duration unit | Price */}
                        <div className="row">
                          {/* Course Duration */}
                          <div className="col-md-5">
                            <div className="form-floating form-floating-outline mb-4  ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Course Duration"
                                value={courseDuration}
                                onChange={handleCourseDurationChange}
                              />
                              <label htmlFor="basic-default-phone">
                                Course Duration
                              </label>
                            </div>
                          </div>
                          {/* Duration unit */}
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-4">
                              <select
                                className="form-select"
                                id="dUnit"
                                aria-label="Default select example"
                                value={durationUnit}
                                onChange={handleDurationUnitChange}
                              >
                                <option value="hours">Hours</option>
                                <option value="days">Days</option>
                                <option value="months">Months</option>
                              </select>
                              <label htmlFor="dUnit">Duration Unit</label>
                            </div>
                          </div>
                          {/* Price */}
                          <div className="col-md-5">
                            <div className="form-floating form-floating-outline mb-4 ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Price"
                                value={courseType === "Watch Free" ? 0 : price}
                                onChange={handlePriceChange}
                              />
                              <label htmlFor="basic-default-phone">Price</label>
                            </div>
                          </div>
                        </div>

                        {/* End Date | Start Date  */}
                        <div className="row">
                          {/* Start Date */}
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                className="form-control"
                                type="datetime-local"
                                id="html5-datetime-local-input"
                                value={startDateTime}
                                onChange={handleStartDateTimeChange}
                              />
                              <label htmlFor="html5-datetime-local-input">
                                Start Date/Time
                              </label>
                            </div>
                          </div>
                          {/* End Date */}
                          <div className="col-md-6">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                className="form-control"
                                type="datetime-local"
                                id="html5-datetime-local-input"
                                value={endDateTime}
                                onChange={handleEndDateTimeChange}
                              />
                              <label htmlFor="html5-datetime-local-input">
                                End Date/Time
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Category */}
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Category"
                            value={category}
                            onChange={handleCategoryChange}
                          />
                          <label htmlFor="basic-default-company">
                            Category
                          </label>
                        </div>

                        {/* Target Audience */}
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Target Audience"
                            value={targetAudience}
                            onChange={handleTargetAudienceChange}
                          />
                          <label htmlFor="basic-default-company">
                            Target Audience
                          </label>
                        </div>
                      </>
                    )}

                    {/* Short Description */}
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        id="basic-default-company"
                        placeholder="Short Description"
                        value={shortDescription}
                        onChange={handleShortDescriptionChange}
                      />
                      <label htmlFor="basic-default-company">
                        Short Description
                      </label>
                    </div>

                    {/* Long Description */}
                    <div className="form-floating form-floating-outline mb-4">
                      <textarea
                        id="basic-default-message"
                        className="form-control"
                        placeholder="Long Description"
                        style={{ height: "60px" }}
                        value={longDescription}
                        onChange={handleLongDescriptionChange}
                      ></textarea>
                      <label htmlFor="basic-default-message">
                        Long Description
                      </label>
                    </div>

                    {/* Teacher | Chapters */}
                    {!onlyMcq && (
                      <>
                        {/*  Teacher */}
                        <div className="form-floating form-floating-outline mb-4 ">
                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            options={teachers}
                            value={selectedTeachers}
                            placeholder="Select Teachers"
                            onChange={handleTeachersChange}
                          />
                        </div>

                        {/*  Chapters */}
                        <label htmlFor="chap" className="mb-2">
                          Chapters
                        </label>
                        <div className="form-floating form-floating-outline mb-4 ">
                          <DualListBox
                            items={chapOptions}
                            selected={selectedChapOptions}
                            changeOption={setSelectedChapters}
                          />
                        </div>
                      </>
                    )}

                    {/* Plans */}
                    {!id && (
                      <>
                        <div>
                          <label className="form-check-label ml-1 mb-2">
                            Plans
                          </label>
                          {plans.map((plan, i) => (
                            <div key={i} className="row">
                              {/*  Duration */}
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4  ">
                                  <input
                                    type="number"
                                    min="1"
                                    id="basic-default-phone"
                                    className="form-control phone-mask"
                                    placeholder="Duration"
                                    value={plan.duration}
                                    name="duration"
                                    onChange={(e) => handlePlanChange(e, i)}
                                  />
                                  <label htmlFor="basic-default-phone">
                                    Duration
                                  </label>
                                </div>
                              </div>
                              {/* Duration unit */}
                              <div className="col-sm-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <select
                                    className="form-select"
                                    id="exampleFormControlSelect1"
                                    aria-label="Default select example"
                                    value={plan.durationUnit}
                                    name="durationUnit"
                                    onChange={(e) => handlePlanChange(e, i)}
                                  >
                                    <option value="days">Days</option>
                                    <option value="weeks">Weeks</option>
                                    <option value="months">Months</option>
                                  </select>
                                  <label htmlFor="exampleFormControlSelect1">
                                    Duration Unit
                                  </label>
                                </div>
                              </div>
                              {/* Price */}
                              <div className="col-md-3">
                                <div className="form-floating form-floating-outline mb-4 ">
                                  <input
                                    type="number"
                                    min="1"
                                    id="basic-default-phone"
                                    className="form-control phone-mask"
                                    placeholder="Price"
                                    value={plan.price}
                                    name="price"
                                    onChange={(e) => handlePlanChange(e, i)}
                                  />
                                  <label htmlFor="basic-default-phone">
                                    Price
                                  </label>
                                </div>
                              </div>
                              {/* promotional_price */}
                              <div className="col-md-3">
                                <div className="form-floating form-floating-outline mb-4 ">
                                  <input
                                    type="number"
                                    min="1"
                                    id="basic-default-phone"
                                    className="form-control phone-mask"
                                    placeholder="Promotional Price"
                                    value={plan.promotional_price}
                                    name="promotional_price"
                                    onChange={(e) => handlePlanChange(e, i)}
                                  />
                                  <label htmlFor="basic-default-phone">
                                    Promotional Price
                                  </label>
                                </div>
                              </div>
                              {/* cancel plan */}
                              {i > 0 && (
                                <div
                                  className="text-red-600 col-sm-2 select-none"
                                  onClick={() => handleRemovePlanBtn(i)}
                                >
                                  <span className="mdi mdi-close pr-2"></span>
                                  Remove Plan
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-secondary mb-4 "
                          onClick={() => handleAddPlanBtn()}
                        >
                          Add More Plan
                        </button>
                        <hr className="mb-4 mt-2" />
                      </>
                    )}

                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="recordedVideoLink"
                        id="recordedVideoLink"
                        placeholder="Live Class Link"
                        value={formData.recordedVideoLink}
                        onChange={handleChange}
                      />
                      <label htmlFor="recordedVideoLink">Live Class Link</label>
                    </div>
                    {/* Live Class | liveClassLink | liveClassStart | liveClassEnd | liveClassDesc | liveClassInstFile | isChapEnblDuringLiveClass | Description File Link | Materials Link | Image Link | Video Link | Incentive  */}
                    {!onlyMcq && (
                      <>
                        {/* Live Class | liveClassLink | liveClassStart | liveClassEnd | liveClassDesc | liveClassInstFile | isChapEnblDuringLiveClass */}
                        <div className="row">
                          {/* Live Class */}
                          <div className="col-sm-3 my-auto">
                            <div className="">
                              <div
                                className="mb-4  px-3 select-none"
                                onClick={handleLiveClassLinkBtn}
                              >
                                {formData.liveClassStatus ? (
                                  <span className="mdi mdi-checkbox-marked-outline mr-3  "></span>
                                ) : (
                                  <span className="mdi mdi-checkbox-blank-outline mr-3 "></span>
                                )}
                                <span>Live Class</span>
                                <span
                                  style={{
                                    visibility: formData.liveClassStatus
                                      ? "hidden"
                                      : "visible",
                                  }}
                                >
                                  ?
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* liveClassLink | liveClassStart | liveClassEnd | liveClassDesc | liveClassInstFile | isChapEnblDuringLiveClass */}
                          {formData.liveClassStatus && (
                            <>
                              {/* liveClassLink  */}
                              <div className="col-sm-9 ">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="liveClassLink"
                                    id="liveClassLink"
                                    placeholder="Live Class Link"
                                    value={formData.liveClassLink}
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="liveClassLink">
                                    Live Class Link
                                  </label>
                                </div>
                              </div>
                              {/* liveClassDesc  */}
                              <div className="col-lg-12 ">
                                <div className="form-floating form-floating-outline mb-4">
                                  <textarea
                                    id="liveClassDesc"
                                    className="form-control"
                                    placeholder="Live Class Description"
                                    style={{ height: "60px" }}
                                    name="liveClassDesc"
                                    value={formData.liveClassDesc}
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="liveClassDesc">
                                    Live Class Description
                                  </label>
                                </div>
                              </div>
                              {/* liveClassStart */}
                              <div className="col-md-12 ">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    name="liveClassStart"
                                    id="liveClassStart"
                                    placeholder="Live Class Start"
                                    value={formData.liveClassStart}
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="liveClassStart">
                                    Live Class Start
                                  </label>
                                </div>
                              </div>
                              {/* liveClassEnd */}
                              {/* <div className="col-md-6 ">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="datetime-local"
                                className="form-control"
                                name="liveClassEnd"
                                id="liveClassEnd"
                                placeholder="Live Class End"
                                value={formData.liveClassEnd}
                                onChange={handleChange}
                              />
                              <label htmlFor="liveClassEnd">
                                Live Class End
                              </label>
                            </div>
                          </div> */}

                              {/* liveClassInstFile */}
                              <div className="col-md-6">
                                <div className="form-floating form-floating-outline  w-full mb-4">
                                  <input
                                    type="file"
                                    className="form-control"
                                    name="liveClassInstFile"
                                    id="liveClassInstFile"
                                    onChange={handleChange}
                                  />
                                  <label htmlFor="liveClassInstFile">
                                    Instruction File
                                  </label>
                                </div>
                              </div>

                              {/* isChapEnblDuringLiveClass */}
                              <div className="col-sm-6">
                                <div className="form-floating form-floating-outline mb-4">
                                  <select
                                    className="form-select"
                                    id="isChapEnblDuringLiveClass"
                                    name="isChapEnblDuringLiveClass"
                                    aria-label="Default select example"
                                    value={formData.isChapEnblDuringLiveClass}
                                    onChange={handleChange}
                                  >
                                    <option
                                      value=""
                                      disabled
                                      selected
                                      className="text-center"
                                    >
                                      ---- Is Chapter Enable During Live Class?
                                      ----
                                    </option>
                                    <option value="1">Enable</option>
                                    <option value="0">Disable</option>
                                  </select>
                                  <label htmlFor="isChapEnblDuringLiveClass">
                                    Is Chapter Enable During Live Class?
                                  </label>
                                </div>
                              </div>
                              <hr />
                            </>
                          )}
                        </div>

                        {/* Description File Link */}
                        <MediaPopup
                          ttl="Description"
                          linkValue={descFileLinkValue}
                          setLinkValue={setDescFileLinkValue}
                          setFileValue={setDescFileImageValue}
                          mediaType="allfiles"
                        />

                        {/* Materials Link */}
                        <MediaPopup
                          ttl="Materials"
                          linkValue={materialsLinkValue}
                          setLinkValue={setMaterialsLinkValue}
                          setFileValue={setMaterialsFileImageValue}
                          mediaType="allfiles"
                         // multiple
                        />

                        {/* Image Link | Video Link */}
                        <div className="row ml-4">
                          {/* Image Link */}
                          <MediaPopup
                            ttl="Image"
                            linkValue={imageLinkValue}
                            setLinkValue={setImageLinkValue}
                            setFileValue={setImageFileImageValue}
                            mediaType="images"
                          />

                          {/* Video Link */}
                          <MediaPopup
                            ttl="Video"
                            linkValue={videoLinkValue}
                            setLinkValue={setVideoLinkValue}
                            setFileValue={setVideoFileImageValue}
                            mediaType="videos"
                          />
                          <MediaPopup
                            ttl="VideoThumbnail"
                            linkValue={videoThumbnailValue}
                            setLinkValue={setVideoThumbnailValue}
                            setFileValue={setVideoThumbnailFileImageValue}
                            mediaType="images"
                          />
                        </div>

                        {/* Incentive */}
                        {user_type === "TPT" && (
                          <div className="">
                            <div className="form-floating form-floating-outline mb-4 ">
                              <input
                                type="number"
                                min="1"
                                max="100"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Incentive"
                                value={incentive}
                                onChange={incentiveValueChange}
                              />
                              <label htmlFor="basic-default-phone">
                                Incentive
                              </label>
                            </div>
                          </div>
                        )}
                      </>
                    )}

                    {/* submit | save | calcel */}
                    <div className="mt-3 justify-content-end">
                      <div className="col-sm-10">
                        {/* save */}

                        <button
                          type="button"
                          className="btn mr-2 btn-info"
                          onClick={saveCourse}
                        >
                          save
                        </button>

                        {/* submit */}
                        <button
                          type="button"
                          className="btn  btn-primary"
                          onClick={createCourse}
                        >
                          Submit
                        </button>

                        {/* clear - calcel */}
                        <button
                          type="button"
                          className="btn ml-2 btn-secondary"
                          onClick={clearForm}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </>
      ) : checkCourseList === false ? (
        <div className="flex justify-center">
          <p>Unfortunately, You are not able to create a course!</p>
        </div>
      ) : (
        <div className="flex justify-center">
          <Spinner />
        </div>
      )}

      {/* materials popup */}
      <div
        className="modal fade"
        id="addNewMaterialsModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple modal-add-new-cc">
          <div className="modal-content p-3 p-md-5">
            <div className="modal-body p-md-0">
              <h5 className="card-header pb-2">Select File</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearSelectedMaterialsMedia}
              ></button>

              <div className="row">
                {files.map((media) => (
                  <div className="col-md-3 mb-3" key={media.media_id}>
                    <div className="form-check custom-option custom-option-image custom-option-image-check ">
                      <input
                        className="form-check-input invisible"
                        id={`Materials_${media.media_id}`}
                        type="checkbox"
                        value={media.media_id}
                        checked={
                          selectedMaterials &&
                          selectedMaterials.media_id === media.media_id
                        }
                        onChange={() => handleSelectMaterialsMedia(media)} //popupFunc1
                      />

                      <label
                        className="form-check-label custom-option-content"
                        htmlFor={`Materials_${media.media_id}`}
                      >
                        <span className="custom-option-body">
                          <img
                            src={media.media_name}
                            alt={`cbImg${media.media_id}`}
                          />
                        </span>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Select
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCourse;
//1561 lines
